<template>
    <div class="__page">
        <Samplingbox
            :flags="samplingbox.flags"
            :header-html="samplingbox.headerHtml"
            :footer-html="samplingbox.footerHtml"
            :benefits-html="campaignData.benefits1"
            :samples="samples"
            :is-disabled="isCheckingDisabled"
            @changeAnySelected="snapshot => isFormboxOpen = snapshot"
            @changeSample="snapshot => selectedSampleId = snapshot"
        />
        <FormboxSampling
            v-if="!checkResponse"
            :is-open="isFormboxOpen"
            :selectedSampleId="selectedSampleId"
            @submit="onSubmitForm"
        />
        <Component
            v-if="checkResponse"
            :is="checkResponse.component"
            :data="checkResponse.data"
        />

        <Modal
            :is-closeable="true"
            closeLabel="Zamknij okno"
            ref="modal"
        />

        <div class="wrapper">
            <ImageLazy
                image-url="/uploads/images/wybor-szefow.png"
                :height="136"
                alt=""
                class="sampling-sticker"
            />
        </div>
    </div>
</template>

<script>
import BadgeboxAlreadyTaken from '@/components/badgebox/BadgeboxAlreadyTaken'
import BadgeboxNoConsent from '@/components/badgebox/BadgeboxNoConsent'
import BadgeboxSuccess from '@/components/badgebox/BadgeboxSuccess'
import BadgeboxSuccessNoSample from '@/components/badgebox/BadgeboxSuccessNoSample'
import FormboxSampling from '@/components/formbox/FormboxSampling'
import Modal from '@/components/modal/Modal'
import Samplingbox from '@/components/samplingbox/Samplingbox'
// import SamplingService from '@/service/SamplingService'

export default {
    components: {
        BadgeboxAlreadyTaken,
        BadgeboxNoConsent,
        BadgeboxSuccess,
        BadgeboxSuccessNoSample,
        FormboxSampling,
        Modal,
        Samplingbox
    },

    data() {
        return {
            isCheckingDisabled: false,
            checkResponse: null,
            isFormboxOpen: false,
            selectedSampleId: 0,
            samplingbox: {
                headerHtml: `
                    <p class="fs-24 text-bold-regular">
                        Jesteś klientem Makro? Posiadasz swoją gastronomię?
                    </p>
                    <h1 class="fs-59">
                        Wypróbuj produkty Makro Chef!
                    </h1>
                    <div class="grid grid-space-50">
                        <p class="samplingbox-header-custom-1 fs-16 fs-lh-20 text-left">
                            Makro Chef  to asortyment dla gastronomii, stworzony przy współpracy z Szefami kuchni.
                            Są to produkty wysokiej jakości, w dobrej cenie, dostępne w różnych wielkościach opakowań. Za to wszystko cenią je nasi Klienci.
                        </p>
                        <p class="samplingbox-header-custom-2 fs-16 fs-lh-20 text-left">
                            Co miesiąc <strong class="text-bold">100 pierwszych klientów</strong> może otrzymać <strong class="text-bold">do przetestowania<br/>za darmo</strong> jeden z trzech produktów Makro Chef.<br/>
                            <strong class="text-bold">Kliknij poniżej i zamów jeden z wybranych produktów.</strong>
                        </p>
                    </div>
                    <p class="samplingbox-header-custom-3 fs-16 fs-lh-20">
                        Jeśli nie zdążyłeś zamówić produktu testowego <strong class="text-bold">mamy dla Ciebie kupon rabatowy.</strong>
                    </p>
                `,
                footerHtml: `
                    <p class="fs-15 text-center"><strong style="font-weight: 700; text-transform: uppercase;">teraz możesz wypróbować te produkty za darmo!</strong><br>*Cena regularna.</p>
                `
            }
        }
    },

    computed: {
        campaignData() {
            return this.$store.getters['apiCampaign/campaign']
        },

        samples() {
            return this.campaignData.articles.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    bodyHtml: item.description,
                    image: {
                        imageUrl: item.image,
                        height: 353
                    }
                }
            })
        }
    },

    methods: {
        onSubmitForm(payload) {
            this.$store.dispatch('siteLoader/open')

            this.$store
                .dispatch('apiSample/checkSample', payload)
                .then(() => {
                    const sampleData = this.$store.getters['apiSample/sample']

                    // ALREADY TAKEN
                    if (sampleData.alreadyTaken && sampleData.alreadyTaken === true) {
                        this.checkResponse = {
                            component: BadgeboxAlreadyTaken,
                            data: {
                                key: 'already-taken'
                            }
                        }

                        this.$store.dispatch('apiCampaign/clearCampaign')
                    }

                    // WSZYSTKO OK
                    else if (sampleData.consentStatus === true && sampleData.freeSample === true) {
                        this.checkResponse = {
                            component: BadgeboxSuccess,
                            data: {
                                key: 'success'
                            }
                        }

                        this.$store.dispatch('apiCampaign/clearCampaign')
                    }

                    // ZGODA JEST, BRAK SAMPLA
                    else if (sampleData.consentStatus === true && !sampleData.freeSample) {
                        this.checkResponse = {
                            component: BadgeboxSuccessNoSample,
                            data: {
                                key: 'success-no-sample'
                            }
                        }

                        this.$store.dispatch('apiCampaign/clearCampaign')
                    }

                    // BRAK ZGODY -- KONIECZNE LOGOWANIE
                    else {
                        this.checkResponse = {
                            component: BadgeboxNoConsent,
                            data: {
                                selectedSampleId: this.selectedSampleId,
                                email: sampleData.email,
                                partCard1: payload.partCard1,
                                partCard2: payload.partCard2,
                                partCard3: payload.partCard3,
                                firstName: payload.firstName,
                                lastName: payload.lastName
                            }
                        }
                    }
                })
                .catch(e => {
                    this.$refs.modal
                        .open(`<header class="fs-32">Błąd logowania.</header><p class="fs-22">Upewnij się, że podane dane są poprawne.</p>`, 'center-small', function() {

                        })

                    console.warn(e.response)
                })
                .finally(() => {
                    this.$store.dispatch('siteLoader/close')
                    this.isCheckingDisabled = true
                })
        }
    }
}
</script>

<style lang="scss">
.sampling-sticker {
    top: 10px;
    right: calc(50% - 74px);
    z-index: 4000;

    &.image-lazy {
        position: fixed;
    }

    @media (max-width: $screen-mobile-landscape) {
        &.image-lazy {
            img {
                width: 50%;
                position: relative;
                left: 37px;
            }
        }
    }
}
</style>
